import { ActionFunction, ActionObject, Machine, State as BaseState } from 'xstate'

import { Event } from '@skinsoft/rxstate'

export type AuthEvent = Event<'AUTHENTICATE'> | Event<'CHALLENGE'> | Event<'DEAUTHENTICATE'>

export type AuthStateValue = 'authenticated' | 'challenging' | 'idle' | 'unauthenticated'

export interface AuthStateSchema {
    states: Record<AuthStateValue, {}>;
}

export interface AuthContext {
    userId?: string;
}

export type State = BaseState<AuthContext, AuthEvent>;

interface Actions
    extends Record<
        string,
        ActionObject<AuthContext, AuthEvent> | ActionFunction<AuthContext, AuthEvent>
    > {
    beginChallenge(context: AuthContext, event: AuthEvent): void;
    clearStorage(context: AuthContext, event: AuthEvent): void;
    startUserPolling(context: AuthContext, event: AuthEvent): void;
    stopUserPolling(context: AuthContext, event: AuthEvent): void;
    storeUserId(context: AuthContext, event: AuthEvent): void;
}

export function createMachine(actions: Actions) {
    return Machine<AuthContext, AuthStateSchema, AuthEvent>(
        {
            id: 'auth',
            initial: 'idle',
            states: {
                authenticated: {
                    entry: ['storeUserId', 'startUserPolling'],
                    on: {
                        DEAUTHENTICATE: 'unauthenticated',
                    },
                },
                challenging: {
                    entry: ['beginChallenge'],
                    on: {
                        AUTHENTICATE: 'authenticated',
                        DEAUTHENTICATE: 'unauthenticated',
                    },
                },
                idle: {
                    on: {
                        AUTHENTICATE: 'authenticated',
                        CHALLENGE: 'challenging',
                        DEAUTHENTICATE: 'unauthenticated',
                    },
                },
                unauthenticated: {
                    entry: ['stopUserPolling', 'clearStorage'],
                    on: {
                        CHALLENGE: 'challenging',
                    },
                },
            },
        },
        {
            actions,
        },
        {},
    );
}
